var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",style:(("width: " + _vm.width + "; top: " + _vm.top + "; right: " + _vm.right + ";")),attrs:{"src":_vm.src,"alt":"image 🦄"}})}
var staticRenderFns = []

export { render, staticRenderFns }